import { wafflesKeyColumnName } from "@app/shared/waffles";
import InspectionProfileTableData from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/inspectionProfileTableData";
import { getSupplementalDataDecoration, valueOrDashes } from "@app/projects/servicing-provider/accuracy/provider-inspection-profile-components/utils";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { AccuracyInspectionSupplement } from "@app/projects/results/accuracy/accuracyInspectionSupplement";
import { formatUnconvertedDateCustom } from "@app/shared/formatDateTime";

const unknownSourceName = "UNKNOWN";

/* oxlint-disable sort-keys */
const generateDefaultProviderPanelRow = (rowKey: string, title: string, sourceValue: string, supplement: AccuracyInspectionSupplement<string>, supplementValueOveride: string = null): InspectionProfileTableData => {
  return {
    [wafflesKeyColumnName]: rowKey,
    title: title,
    source: valueOrDashes(sourceValue),
    result: (
      supplement ?
        getSupplementalDataDecoration((supplementValueOveride) ? supplementValueOveride : supplement.value, supplement.supplementalType, sourceValue)
        :
        <span className="text-muted">
          <QesIcon iconName={QesIcons.Help} description="The accuracy of this information is unknown" className="mx-2 align-text-top" />
        </span>
    ),
    reference: (
      (supplement && supplement.sourceName?.toUpperCase() !== unknownSourceName) ?
        <span>
          {valueOrDashes(supplement.sourceName)}
          &nbsp;
          {(supplement.sourceName) ?
            valueOrDashes(supplement.sourceDate ? `(${formatUnconvertedDateCustom(supplement.sourceDate, "L")})` : "") :
            null
          }
        </span> :
        <span>{"---"}</span>
    ),
    attesterInfo: (
      (supplement && supplement.attesterName?.toUpperCase() !== unknownSourceName) ?
        <span>
          {valueOrDashes(supplement.attesterName)}
          &nbsp;
          {(supplement.attesterName) ?
            valueOrDashes(supplement.attesterRole ? `(${supplement.attesterRole})` : "") :
            null
          }
        </span> :
        <span>{"---"}</span>
    ),
    attestationMethod: (
        <span>
          {valueOrDashes(supplement?.attestationMethod)}
        </span>
    ),
  }
}

export default generateDefaultProviderPanelRow;